import type { FunctionComponent } from 'react';

import type { PublicUserDataT } from 'utils';

import S from './style.scss';

type PropsT = {
  onClick?: () => void;

  photoUrl?: string;

  size?: number;
  user: PublicUserDataT;
};

const Avatar: FunctionComponent<PropsT> = ({
  onClick, photoUrl, size, user,
}) => {
  let letters = '';
  if (user.firstName) letters += user.firstName[0] ?? '';
  if (user.lastName) letters += user.lastName[0] ?? '';

  let className = S.avatarPlaceholder;
  if (onClick) className += ` ${S.clickable}`;

  const imageUrl = photoUrl ?? user.avatarUrl ?? undefined;

  return (
    <div
      className={className}
      onClick={onClick}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter') onClick();
      } : undefined}
      role={onClick ? 'button' : undefined}
      style={{
        // NOTE: The "magic numbers" 14 and 36 are just the default font and
        // avatar size, defined in SCSS - with the custom size we want to scale
        // the font proportionally.
        fontSize: size ? 14 * size / 36 : undefined,
        height: size,
        width: size,
      }}
      tabIndex={onClick ? 0 : undefined}
    >
      {imageUrl
        ? <img alt="" src={imageUrl} styleName="image" />
        : letters || 'NA'}
    </div>
  );
};

export default Avatar;
